import styled from 'styled-components'
import { colors, fontScope, radius } from '../tokens'

export const Track = styled.div`
  ${fontScope}
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 3px 6px;
  border-radius: ${radius.tabs};
  background: ${colors.accent};
`

export const Tab = styled.button<{ $active: boolean }>`
  flex: 1 0 0;
  min-width: 29px;
  min-height: 29px;
  padding: 4px 8px;
  border: 0;
  border-radius: ${radius.tabs};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
  cursor: pointer;
  background: ${({ $active }) => ($active ? colors.primary : 'transparent')};
  color: ${({ $active }) => ($active ? colors.primaryForeground : colors.ink950)};
  box-shadow: ${({ $active }) =>
    $active ? '0 1px 1.5px rgba(0, 0, 0, 0.1), 0 1px 1px rgba(0, 0, 0, 0.1)' : 'none'};

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`
